import React from 'react';
import './Contact.css';

const Contact = () => {
  const locations = [
    {
      city: 'SHREVEPORT, LA',
      address: ['9441 Stevens Road', 'Suite 100', 'Shreveport, LA 71106']
    },
    {
      city: 'PLEASANT HILL, LA',
      address: ['8516 Stoddard Street', 'Pleasant Hill, LA 71065']
    },
    {
      city: 'TYLER, TX',
      address: ['3200 Troup Hwy', 'Suite 210', 'Tyler, TX 75701']
    },
    {
      city: 'BATON ROUGE, LA',
      address: ['3266 Drusilla Lane', 'Baton Rouge, LA 70809']
    },
    {
      city: 'LAKE CHARLES, LA',
      address: ['121 Jamestown Street', 'Bldg J', 'Lake Charles, LA 70605']
    },
    {
      city: 'WACO, TX',
      address: ['688 Alliance Parkway', 'Suite 14', 'Hewitt, TX 76643']
    },
    {
      city: 'TEXARKANA, TX',
      address: ['5718 Richmond Rd', 'Suite 100', 'Texarkana, TX 75503']
    },
    {
      city: 'WEST MONROE, LA',
      address: ['903 Warren Drive', 'Suite B', 'West Monroe, LA 71291']
    },
    {
      city: 'ABILENE, TX',
      address: ['4400 Buffalo Gap Road', 'Suite 0425', 'Abilene, TX 79606']
    }
  ];

  return (
    <div className="contact-page">
      <div className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="hours-section">
            <h2>Hours of Operation (Business Office)</h2>
            <p className="hours-text">Monday - Friday 8AM - 5PM (CST)</p>
          </div>
          <div className="phone-numbers-section">
            <h2>Phone Numbers</h2>
            <div className="phone-numbers">
              <div className="phone-item">
                <span className="phone-label">Laboratory</span>
                <a href="tel:+18007963894" className="phone-number">1 (800) 796-3894</a>
              </div>
              <div className="phone-item">
                <span className="phone-label">Business Office</span>
                <a href="tel:+13186983250" className="phone-number">(318) 698-3250</a>
              </div>
              <div className="phone-item">
                <span className="phone-label">Billing</span>
                <a href="tel:+15125150065" className="phone-number">(512) 515-0065</a>
              </div>
              <div className="phone-item">
                <span className="phone-label">Stat Pickup</span>
                <a href="tel:+18887961449" className="phone-number">1 (888) 796-1449</a>
              </div>
            </div>
          </div>

          <div className="locations-section">
            <h2>Our Locations</h2>
            <div className="locations-grid">
              {locations.map((location, index) => (
                <div key={index} className="location-card">
                  <h3>{location.city}</h3>
                  <address>
                    {location.address.map((line, lineIndex) => (
                      <React.Fragment key={lineIndex}>
                        {line}
                        {lineIndex < location.address.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </address>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
